import React from "react"
import { Link } from "react-router-dom"
import { stripText } from "../../../util/strings"
import CountdownBlock from "../../shared/CountdownBlock"
import UserAvatar from "../../shared/Header/UserAvatar"

export const ActivityEvent = ({ activityEvent }) => {
  const ACTION_TEXT_MAP = {
    signup_band: {
      text: "just created their band page",
      position: "post",
    },
    live_stream: {
      text: "just went live",
      position: "post",
    },
    created_headline: {
      text: "created the headline",
      position: "pre",
    },
    created_event: {
      text: "created the event",
      position: "pre",
    },
    added_comment: {
      text: "commented on",
      position: "pre",
    },
    added_chat: {
      text: "chatted in",
      position: "pre",
    },
    event_response: {
      text: "is interested in the event",
      position: "pre",
    },
    added_tip: {
      text: "tipped in",
      position: "pre",
    },
    reacted: {
      text: "reacted to",
      position: "pre",
      icon: true,
    },
    play_song: {
      text: "played",
      position: "pre",
    },
    event_performance: {
      format: (ae) => (
        <>
          {`added ${ae.description} to the lineup for `}
          {ae.content_path ? (
            <Link to={{ pathname: ae.content_path, state: { from: true } }} className="text-blue-600">
              {stripText(ae.content_title)}
            </Link>
          ) : (
            <span>{stripText(ae.content_title)}</span>
          )}
        </>
      ),
    },
    referred_signup: {
      format: () => <>referred a friend who joined bandNada!</>,
    },
    created_playlist_post: {
      format: (ae) => {
        const [playlistName, playlistPath] = (ae.description || "").split("|")
        return (
          <>
            {"added "}
            {ae.content_path ? (
              <Link to={{ pathname: ae.content_path, state: { from: true } }} className="text-blue-600">
                {stripText(ae.content_title)}
              </Link>
            ) : (
              <span>{stripText(ae.content_title)}</span>
            )}
            {" to "}
            {playlistPath ? (
              <Link to={playlistPath} className="text-blue-600">
                {playlistName}
              </Link>
            ) : (
              <span>{playlistName || "a playlist"}</span>
            )}
            {" playlist"}
          </>
        )
      },
    },
  }
  const REACTION_ICONS = {
    like: "👍",
    right_on: "✊",
    horns: "🤘",
    fingers_crossed: "🤞",
    ded: "☠️",
  }

  const actionText = ACTION_TEXT_MAP[activityEvent.event_type]

  if (!actionText) {
    // Optionally log or render a fallback
    return null
  }

  return (
    <li className="px-2 py-1 mb-2 rounded-sm text-sm">
      <span className="flex flex-row">
        <UserAvatar
          handleClick={() => {}}
          user={{
            id: activityEvent.user_id,
            avatar_url_small: activityEvent.user_avatar_url,
          }}
          size="small"
          inHeader={false}
        />
        <div className="px-4 w-full">
          <div>
            <span className="text-gray-900 font-bold mr-3">
              {activityEvent.user_path ? (
                <Link to={activityEvent.user_path}>
                  {activityEvent.username}
                </Link>
              ) : (
                activityEvent.username
              )}
            </span>
            <span className="text-gray-700 text-xs date-text">
              {CountdownBlock(activityEvent.created_at, "align-middle")}
            </span>
          </div>
          <div>
            {actionText.format ? actionText.format(activityEvent) : (
              <>
                {actionText.position === "pre"
                  ? `${actionText.icon && activityEvent.description ? REACTION_ICONS[activityEvent.description] ?? actionText.text : actionText.text} `
                  : null}
                {activityEvent.content_path ? (
                  <Link to={{ pathname: activityEvent.content_path, state: { from: true } }} className="text-blue-600">
                    {stripText(activityEvent.content_title)}
                  </Link>
                ) : (
                  <span>{stripText(activityEvent.content_title)}</span>
                )}
                {actionText.position === "post" ? ` ${actionText.text}` : null}
              </>
            )}
          </div>
        </div>
      </span>
    </li>
  )
}
